import { useHeaderStyles } from "./header.styles";
import { HeaderTitleProps } from "../types/index";
import { useBreakpoint } from "@/base/utils/index";
import { Row, Col, Title, Flex, Text } from "@/base/components/index";

export const HeaderTitle = ({
  title,
  subtitle,
  description,
  icon,
}: HeaderTitleProps) => {
  const screens = useBreakpoint();
  const { styles } = useHeaderStyles();

  return (
    <div className={styles.title}>
      <Row gutter={[20, 20]} align="middle" wrap={false}>
        {screens?.md && !!icon && (
          <Col flex="none" className={styles.titleIcon}>
            {icon}
          </Col>
        )}
        <Col flex={1}>
          <Flex vertical>
            {subtitle}
            {title && <Title level={2}>{title}</Title>}
            {description && <Text>{description}</Text>}
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
